import DataGridBoilerplate from "./DataGridBoilerplateComponent";

export default DataGridBoilerplate;
